import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { parseQueryString } from "@saleor/utils/urls";
import * as React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { DropOffListUrlQueryParams } from "./url";
import DropOffCreateNewTemplate from "./views/DropOffCreateNewTemplate";
import DropOffEditTemplate from "./views/DropOffEditTemplate";
import DropOffListComponent from "./views/DropOffList";
import DropOffViewTemplate from "./views/DropOffViewTemplate";

const DropOffList: React.FC = () => {
  const location = useLocation();
  const params = parseQueryString<DropOffListUrlQueryParams>(
    location.search.substring(1)
  );

  return <DropOffListComponent params={params} />;
};

const DropOffView: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const params = parseQueryString<DropOffListUrlQueryParams>(
    location.search.substring(1)
  );

  return <DropOffViewTemplate params={params} id={decodeURIComponent(id)} />;
};

const DropOffEdit: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const params = parseQueryString<DropOffListUrlQueryParams>(
    location.search.substring(1)
  );

  return <DropOffEditTemplate params={params} id={decodeURIComponent(id)} />;
};

const DropOffCreateTemplate: React.FC = () => {
  const location = useLocation();
  const params = parseQueryString<DropOffListUrlQueryParams>(
    location.search.substring(1)
  );

  return <DropOffCreateNewTemplate params={params} />;
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.dropOff)} />
      <Routes>
        <Route path={""} element={<DropOffList />} />
        <Route path={"create"} element={<DropOffCreateTemplate />} />
        <Route path={"edit/:id"} element={<DropOffEdit />} />
        <Route path={":id"} element={<DropOffView />} />
      </Routes>
    </>
  );
};

export default Component;
